import WaydImpactBar from "./WaydImpactBar";

export default WaydImpactBar;
